import React, { useState } from "react";
import { Row, Col } from "react-bootstrap"
import { format } from "date-fns"
import "./scss/customer.scss";
import styles from "../../styles/popupInfor.module.css"

const ChildOrder = ({ order, customer }) => {
  function convertCurrency(data) {
    let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
    return res;
  };

  return (
    <div style={{ borderBottom: "1px solid #d3dae7", marginTop: "10px", }} className="w-100">
      <Row className="align-items-baseline">
        <Col xs={3}>
          <ul style={{ margin: "0px", padding: "0px" }}>
            <li className={styles.orderId}>#{order.order_code}</li>
            <li className={styles.textFormatDateChildOrder}>{format(new Date(order.order_at), 'MM/dd/yyyy - HH:mm')}</li>
          </ul>
        </Col>
        <Col xs={7}>
          <div className="w-100">
            {order.orderItem.map((x, i) => {
              return (
                <div key={i} className={styles.tagChildOrder}>
                    {x.product_name}
                </div>
              )
            })}
          </div>
          <div className="w-100">
            {order.orderItem.map((x, i) => {
              return (
                <div key={i}>
                  {x.employee_service_name1 !== "" ? <span className={styles.tagKTV}>{x.employee_service_name1}</span> : null}
                  {x.employee_service_name2 !== "" ? <span className={styles.tagKTV}>{x.employee_service_name2}</span> : null}
                  {x.employee_service_name3 !== "" ? <span className={styles.tagKTV}>{x.employee_service_name3}</span> : null}
                  {x.employee_service_name4 !== "" ? <span className={styles.tagKTV}>{x.employee_service_name4}</span> : null}
                  {x.employee_service_name5 !== "" ? <span className={styles.tagKTV}>{x.employee_service_name5}</span> : null}
                </div>
              )
            })}
          </div>
        </Col>
        <Col xs={2}>
          <div>
            {order.money_owed > 0 && <span className={styles.tagOwed}>Còn nợ: : {convertCurrency(order.money_owed)}</span>}
          </div>
        </Col>
      </Row>
    </div>
  )
}
export default ChildOrder